/* Upsell-vinkje in het koopblok.
   1) Zet bij aangevinkt een tweede variant in dezelfde /cart/add-aanroep (items[0]/items[1]).
   2) Houdt de prijs in de koopknop actueel: aantal × variantprijs + (aangevinkt ? upsellprijs : 0). */
if (!customElements.get('product-upsell')) {
  customElements.define(
    'product-upsell',
    class ProductUpsell extends HTMLElement {
      connectedCallback() {
        this.check = this.querySelector('[data-upsell-check]');
        this.form = document.getElementById(this.dataset.formId);
        if (!this.form || !this.check) return;

        var host = this.form.closest('product-form') || this.form;
        host.addEventListener('submit', this.voorSubmit.bind(this), true);

        // Prijs in de knop bijwerken bij vinkje, aantal en variantwissel.
        var werkBij = this.werkKnopprijsBij.bind(this);
        this.check.addEventListener('change', werkBij);
        var qty = this.form.elements.namedItem('quantity');
        if (qty) {
          qty.addEventListener('change', werkBij);
          qty.addEventListener('input', werkBij);
        }
        var info = this.closest('product-info') || document;
        var wacht;
        new MutationObserver(function () {
          clearTimeout(wacht);
          wacht = setTimeout(werkBij, 80);
        }).observe(info, { childList: true, subtree: true });
        werkBij();

        // Info-venster: Dawn's modal-dialog verplaatst zichzelf naar <body>, dus via id opzoeken.
        var self = this;
        var modal = document.getElementById('UpsellModal-' + (this.id || '').replace('ProductUpsell-', ''));
        if (modal) {
          var track = modal.querySelector('[data-upsell-track]');
          var stap = function (richting) {
            if (!track) return;
            track.scrollBy({ left: richting * track.clientWidth, behavior: 'smooth' });
          };
          var prev = modal.querySelector('[data-upsell-prev]');
          var next = modal.querySelector('[data-upsell-next]');
          if (prev) prev.addEventListener('click', function () { stap(-1); });
          if (next) next.addEventListener('click', function () { stap(1); });

          var voegToe = modal.querySelector('[data-upsell-modal-add]');
          if (voegToe) {
            voegToe.addEventListener('click', function () {
              self.check.checked = true;
              self.check.dispatchEvent(new Event('change', { bubbles: true }));
              if (typeof modal.hide === 'function') modal.hide();
            });
          }
        }
      }

      werkKnopprijsBij() {
        var span = this.form.querySelector('.product-form__submit-price');
        if (!span) return;
        var basis = parseInt(span.dataset.basePrice, 10);
        if (isNaN(basis)) return;
        var qtyIn = this.form.elements.namedItem('quantity');
        var aantal = qtyIn ? parseInt(qtyIn.value, 10) || 1 : 1;
        var extra = this.check.checked ? parseInt(this.dataset.upsellPrice, 10) || 0 : 0;
        var totaal = basis * aantal + extra;
        var tekst = '\u00a0\u2014\u00a0' + this.geld(totaal, span.dataset.moneyFormat);
        // Alleen schrijven als het verschilt, anders triggert de observer zichzelf.
        if (span.textContent !== tekst) span.textContent = tekst;
      }

      geld(cent, formaat) {
        var f = formaat || '€{{amount_with_comma_separator}}';
        var euro = cent / 100;
        function met(sep, dec, decimalen) {
          var vast = euro.toFixed(decimalen);
          var delen = vast.split('.');
          var heel = delen[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
          return decimalen ? heel + dec + delen[1] : heel;
        }
        return f
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, met('.', ',', 2))
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, met('.', ',', 0))
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, met(',', '.', 0))
          .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, met("'", '.', 2))
          .replace(/\{\{\s*amount\s*\}\}/g, met(',', '.', 2));
      }

      voorSubmit() {
        if (!this.check.checked) return;
        var form = this.form;
        var idIn = form.elements.namedItem('id');
        var qtyIn = form.elements.namedItem('quantity');
        if (!idIn || idIn.disabled) return;

        var qty = qtyIn ? parseInt(qtyIn.value, 10) || 1 : 1;
        var velden = [
          ['items[0][id]', idIn.value],
          ['items[0][quantity]', qty],
          ['items[1][id]', this.dataset.upsellVariant],
          ['items[1][quantity]', 1],
        ].map(function (p) {
          var i = document.createElement('input');
          i.type = 'hidden';
          i.name = p[0];
          i.value = p[1];
          form.appendChild(i);
          return i;
        });

        idIn.disabled = true;
        if (qtyIn) qtyIn.disabled = true;

        setTimeout(function () {
          idIn.disabled = false;
          if (qtyIn) qtyIn.disabled = false;
          velden.forEach(function (i) { i.remove(); });
        }, 0);
      }
    }
  );
}
